import FeaturesList from 'components/molecules/FeaturesList';
import { useSegmentConfig } from 'helpers/hooks/useSegmentConfig';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { t } from '@i18n';
import { Segment } from '../../data/hooks/useCustomerLimits';

/**
 *  Card format list to render segments of the selected company
 */
export const CompanySegmentsList = ({ segments }: { segments: Segment[] }) => {
  if (segments?.length === 0) {
    return <></>;
  }
  return (
    <Card>
      <CardContent>
        <Stack spacing={1.5}>
          <Typography variant='h2'>{t('CLIENTS:DETAIL:SEGMENTS_LIST')}</Typography>
          <Typography variant='h5'>{t('COMMON:SEGMENT')}</Typography>
          <Box>
            <Stack direction='column' alignItems='flex-start' gap={2}>
              {segments?.map((item: Segment) => (
                <SegmentItem key={item.segmentNumber} item={item} />
              ))}
            </Stack>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
/**
 * Segment to render in list
 * @param item Segment to render
 */
const SegmentItem = ({ item }: { item: Segment }) => {
  const segmentConfig = useSegmentConfig(item.name) as {
    enabled_features: string[];
    date_time_range?: string;
  };
  return (
    <Stack>
      <Typography
        variant='body1'
        key={item.segmentNumber}
      >{`${item.name} (${item.segmentNumber})`}</Typography>
      <Box pl={1}>
        <FeaturesList features={segmentConfig?.enabled_features} />
        {segmentConfig?.date_time_range && (
          <Stack>
            <Typography variant='subtitle2'>
              {t('CLIENTS:DETAIL:PRODUCT_LUNCH_DATE_TIME_RANGE')}
            </Typography>
            <Typography variant='caption'>{segmentConfig?.date_time_range}</Typography>
          </Stack>
        )}
      </Box>
    </Stack>
  );
};
